import React from "react";
import {Link} from "react-router-dom";

import Framework from "@beardeddevops/react.framework";
import {Types} from "components";

import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import {Button} from "reactstrap";
import {LineChart, PieChart} from 'react-chartkick'
import 'chart.js'
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Dashboard_Object} state
 *  @property {object} model
 *  @property {Dashboard_Properties} model.properties
 *  @property {Dashboard_Is} model.is
 *  @property {Dashboard_Has} model.has
 */
export default class NFA extends ObjectOverride {

	constructor(props) {
		super(props, Types.National_Firearms_Acts._name);
		this.state.transactions = [];
		this.state.totals = [];
		this.state.colors = ["#67809f", "#1bbc9b", "#95a5a6", "#c8d046", "#d64635"];
		this.account_level = true;
	}

	handleDataChange = event => {
		this.setState({[event.target.name]: event.target.value});
	};

	//Note: Doesn't need a form() function. Only ever used in a modal
	render() {
		/** @type {National_Firearms_Acts_Object} object */
		let object = this.state;
		let {loading} = this.state;
		/** @type {Locations_Object} */
		let {location} = this.props;
		let locationAddressString = `${location.street_1} ${location.street_2 || ''} ${location.city}, ${location.state} ${location.zip}`;

		// if (object.subscription) {
			return (
				<Card>
					<CardContent>
						<div className={'row'}>
							<div className={'col-md'}>
								<Link className={'location'} data-id={'dashboard-locations-' + location.pkey} variant={"text"}
								      to={"/locations/" + location.pkey}
								      style={{
									      fontSize: '20px',
									      fontWeight: '600',
									      color: '#67809f'
								      }}
								>
									<i className="fa fa-building-o"/>
									<span className="nav-text"><strong>&nbsp;&nbsp;{location.name_display || location.name}</strong>
									</span>
									<br/>
									<span className="nav-text" style={{
										fontSize: '14px',
										fontWeight: '400',
										color: '#7c7c7c',
										fontStyle: 'italic'
									}}>
										{locationAddressString}
									</span>
									<br/>
									<span className="nav-text" style={{
										fontSize: '16px',
										fontWeight: '400',
										color: '#484848',
										fontStyle: 'italic'
									}}>
										<b>{location.subscriptions && <span>{location.subscriptions.description}</span>}</b>
									</span>
								</Link>
							</div>
							<div className={'col-md'}>

							</div>
							<div className={'col-md-3'}>
								<div className={'row d-flex'} style={{marginBottom: '10px'}}>
									<div className={'flex-grow-1'}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="send_ffl_license_email"
											label="Email a copy of My FFL"
											value={this.state.email}
											onChange={this.handleDataChange}
										/>
									</div>
									<div style={{marginTop: '-1px'}} className={'mr-auto'}>
										<Button style={{height: '32px', width: '50px'}} className={'btn-block green-meadow'} onClick={() => {
										}}>Send</Button>
									</div>
								</div>
							</div>
						</div>
						<hr/>
						<div>
							<Card style={{
								backgroundColor: '#67809f',
								border: '3px solid',
								borderColor: '#a2a2a2',
								width: '280px',
								display: 'inline-block',
								marginRight: '20px'
							}}>
								<CardContent style={{padding: '8px 8px 4px', height: '70px'}}>
									<p style={{
										fontSize: '17px',
										fontWeight: '300',
										marginBottom: '0',
										color: 'white'
									}} className="nav-text">{location.bound_book || 'Primary'}</p>
									<span style={{
										fontSize: '12px',
										color: 'white'
									}}>Default bound book for this location.
									</span>
								</CardContent>
								<CardActions style={{padding: '4px 8px 8px'}}>
									<span style={{
										marginRight: 'auto',
										color: 'white',
										fontSize: '10px',
										width: 'auto',
										lineHeight: '12px',
										marginTop: '4px'
									}}>
									</span>
									<Button onClick={() => this.props.history.push("/locations/" + location.pkey)}
									        id={"button-login"} color="green-meadow" size={"sm"}>
										<i className="fa fa-book"/>
									</Button>
									<Button
										onClick={() => this.props.history.push('/bound_book_generate/' + location.pkey + '/download_for_location')}
										color="primary" size={"sm"}>
										<i className="fa fa-download"/>
									</Button>
								</CardActions>
							</Card>
						</div>
						<hr/>
						<div>
							<div className={'row'}>
								<div className={'col-md-9'}>
									<h5>Transactions Over 30 Days</h5>
									<LineChart colors={this.state.colors} data={this.state.transactions}/>
								</div>
								<div className={'col-md-3'}>
									<h5>30 Day Total By Transaction Type</h5>
									<PieChart colors={this.state.colors} data={this.state.totals}/>
								</div>
							</div>
						</div>

						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</CardContent>
				</Card>
			)
		// } else {
		// 	return ('');
		// }
	}
}
